import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Typography,
    Box,
    Slide
} from '@mui/material';
import { ShieldCheck } from 'lucide-react';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmationModal = ({ open, onClose, onConfirm, title, description, loading }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            keepMounted
            PaperProps={{
                sx: {
                    borderRadius: '16px',
                    padding: '16px',
                    width: '100%',
                    maxWidth: '400px',
                    position: 'absolute',
                    bottom: { xs: 20, sm: 'auto' } // Optional: Keep it near bottom on mobile
                }
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', pt: 2 }}>
                <Box
                    sx={{
                        backgroundColor: '#E8F5E8',
                        borderRadius: '50%',
                        padding: '12px',
                        marginBottom: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <ShieldCheck size={32} color="#2E7D32" />
                </Box>
                <DialogTitle sx={{ p: 0, mb: 1 }}>
                    <Typography variant="h6" fontWeight="600" color="#111827">
                        {title || "Confirm Action"}
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ p: 0, mb: 3 }}>
                    <DialogContentText sx={{ color: '#6B7280', fontSize: '0.95rem' }}>
                        {description || "Are you sure you want to proceed with this action?"}
                    </DialogContentText>
                </DialogContent>
            </Box>
            <DialogActions sx={{ p: 0, display: 'flex', gap: 2, justifyContent: 'center' }}>
                <Button
                    disableElevation
                    onClick={onClose}
                    variant="outlined"
                    disabled={loading}
                    sx={{
                        borderColor: '#E5E7EB',
                        color: '#374151',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 500,
                        px: 3,
                        py: 1,

                    }}
                >
                    Cancel
                </Button>
                <Button
                    disableElevation
                    onClick={onConfirm}
                    variant="contained"
                    disabled={loading}
                    sx={{
                        backgroundColor: '#FFBD65',
                        color: 'white',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 500,
                        px: 3,
                        py: 1,
                        boxShadow: 'none',

                    }}
                >
                    {loading ? 'Processing...' : 'Confirm'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationModal;
